import Loading from '../../../Common/Loading';
import { useBPCChartsDataContext } from './hooks/useBPCChartsDataContext';
import { PaymentsYearAvg } from './PaymentsYearAvg';
import { PaymentsYearSum } from './PaymentsYearSum';
import { PaymentsMonthAvg } from './PaymentsMonthAvg';
import { PaymentsMonthSum } from './PaymentsMonthSum';

export const Charts = () => {
    const { isLoading } = useBPCChartsDataContext();

    if (isLoading) {
        return (
            <Loading message="Devido ao alto volume de informações, essa operação pode levar alguns instantes." />
        );
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <PaymentsYearSum/>
                <PaymentsMonthSum/>
            </div>
            <div className="charts-side-by-side-dashboards">
                <PaymentsYearAvg />
                <PaymentsMonthAvg />
            </div>
        </>
    );
};
